import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=2dfa60a8&scoped=true&"
import script from "./Speed.vue?vue&type=script&lang=js&"
export * from "./Speed.vue?vue&type=script&lang=js&"
import style0 from "./Speed.vue?vue&type=style&index=0&id=2dfa60a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa60a8",
  null
  
)

export default component.exports